/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral'
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import FavoriteIcon from '@mui/icons-material/Favorite'


import { positionChangeWidthSm, navbarHeight, footerHeight, tinderProfileImageWidth, tinderProfileItemBoxShadow, tinderProfileItemBorderRadius, tinderProfileItemBorderColor, tinderProfileItemBorderWidth, hingeProfileImageDimension, hingeProfileItemBoxShadow, hingeProfileItemBorderRadius, hingeProfileItemBorderColor, hingeProfileItemBorderWidth, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfilePromptTextColor, swipelyticsTurquoise, profPicDefaultURL } from '../../../helpers/variableDefaults'
import { getPayload, getUserIdFromToken, getTokenFromLocalStorage } from '../../../helpers/storage'
import { descriptionTextField } from '../../../helpers/textfields'

export const giveElementFeedbackJSX = (reviewComponentType, componentIndex, isFriendReview, profileReview, setProfileReview, width, errors, setErrors, loading, setLoading) => {

  const userIsClient = () => {
    return !isFriendReview && getUserIdFromToken(getTokenFromLocalStorage()).toString() === profileReview.userId.toString()
  }

  const handleFeedbackAndVerdictChange = (e, setErrors, setForm, form, index, verdict = '') => {
    e.preventDefault()
    // console.log('handleFeedbackChange runs')

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('verdict ->', verdict)
    
    if (reviewComponentType === 'mediaItem') {
      // console.log('update media item verdict')
      const updatedProfileMediaFeedback = [ ...profileReview.mediaFeedback ]
      updatedProfileMediaFeedback[componentIndex][verdict.length > 0 ? 'verdict' : 'feedback'] = verdict.length > 0 ? verdict : value
      setProfileReview({ ...profileReview, mediaFeedback: updatedProfileMediaFeedback })
    } else if (reviewComponentType === 'prompt') {
      // console.log('update prompt verdict')
      const updatedProfileBioFeedback = { ...profileReview.bioFeedback }
      updatedProfileBioFeedback.promptsFeedback[componentIndex][verdict.length > 0 ? 'verdict' : 'feedback'] = verdict.length > 0 ? verdict : value
      setProfileReview({ ...profileReview, bioFeedback: updatedProfileBioFeedback })
    } else if (reviewComponentType === 'aboutMe') {
      // console.log('update aboutMe verdict')
      const updatedProfileBioFeedback = { ...profileReview.bioFeedback }
      updatedProfileBioFeedback.aboutMeFeedback[verdict.length > 0 ? 'verdict' : 'feedback'] = verdict.length > 0 ? verdict : value
      setProfileReview({ ...profileReview, bioFeedback: updatedProfileBioFeedback })
    } else if (reviewComponentType === 'vitalInfo') {
      // console.log('update vital info verdict')
      const updatedProfileBioFeedback = { ...profileReview.bioFeedback }
      updatedProfileBioFeedback.vitalInfoFeedback[verdict.length > 0 ? 'verdict' : 'feedback'] = verdict.length > 0 ? verdict : value
      setProfileReview({ ...profileReview, bioFeedback: updatedProfileBioFeedback })
    } 
  }

  const feedbackElementBackgroundColor = () => {
    return (
      (
        reviewComponentType === 'mediaItem'
        && 
        (
          profileReview.mediaFeedback[componentIndex].feedback.length > 0 
          || isFriendReview
        )
        && profileReview.mediaFeedback[componentIndex].verdict.length > 0
      )
      ||
      (
        reviewComponentType === 'prompt'
        && 
        (
          profileReview.bioFeedback.promptsFeedback[componentIndex].feedback.length > 0
          || isFriendReview
        )
        && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict.length > 0
      )
      ||
      (
        reviewComponentType === 'aboutMe'
        && 
        (
          profileReview.bioFeedback.aboutMeFeedback.feedback.length > 0
          || isFriendReview
        )
        && profileReview.bioFeedback.aboutMeFeedback.verdict.length > 0
      )
      ||
      (
        reviewComponentType === 'vitalInfo'
        &&
        (
          profileReview.bioFeedback.vitalInfoFeedback.feedback.length > 0
          || isFriendReview
        )
        && profileReview.bioFeedback.vitalInfoFeedback.verdict.length > 0
      )
        ?
        'lightblue'
        :
        'mistyrose'
    )
  }

  return (
    <Box
      sx={{
        mt: 0, py: 2,
        width: profileReview.type === 'bumble' ? bumbleProfileImageWidth(width) : profileReview.type === 'tinder' ? tinderProfileImageWidth(width) : profileReview.type === 'hinge' ? hingeProfileImageDimension(width) : hingeProfileImageDimension(width),
        // backgroundColor: 'mistyrose',
        backgroundColor: feedbackElementBackgroundColor(),
        border: profileReview.type === 'bumble' ? bumbleProfileItemBorderWidth : profileReview.type === 'tinder' ? tinderProfileItemBorderWidth : profileReview.type === 'hinge' ? hingeProfileItemBorderWidth : hingeProfileItemBorderWidth,
        borderColor: profileReview.type === 'bumble' ? bumbleProfileItemBorderColor : profileReview.type === 'tinder' ? tinderProfileItemBorderColor : profileReview.type === 'hinge' ? hingeProfileItemBorderColor : hingeProfileItemBorderColor,
        boxShadow: profileReview.type === 'bumble' ? bumbleProfileItemBoxShadow : profileReview.type === 'tinder' ? tinderProfileItemBoxShadow : profileReview.type === 'hinge' ? hingeProfileItemBoxShadow : hingeProfileItemBoxShadow, 
        borderRadius: profileReview.type === 'bumble' ? `0px 0px 0px 0px` : profileReview.type === 'tinder' ? `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}` : `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}`,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >
      {userIsClient()
        ?
        <Box>
          The review has not been submitted yet.
        </Box>
        :
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >

          {/* Feedback Text */}
          <Box
            sx={{
              px: 2,
              mt: 1,
              width: '100%',
            }}
          >
            {descriptionTextField(
              'feedback',
              reviewComponentType === 'mediaItem' ? profileReview.mediaFeedback[componentIndex].feedback : reviewComponentType === 'prompt' ? profileReview.bioFeedback.promptsFeedback[componentIndex].feedback : reviewComponentType === 'aboutMe' ? profileReview.bioFeedback.aboutMeFeedback.feedback : reviewComponentType === 'vitalInfo' ? profileReview.bioFeedback.vitalInfoFeedback.feedback : '',
              -1,
              // reviewComponentType === 'mediaItem' ? `Feedback` : reviewComponentType === 'prompt' ? `Feedback` : reviewComponentType === 'aboutMe' ? `Feedback` : reviewComponentType === 'vitalInfo' ? `Feedback` : ``,
              ``,
              isFriendReview ? 2 : 5,
              300,
              `Does this ${reviewComponentType === 'mediaItem' ? 'image' : reviewComponentType === 'vitalInfo' ? 'vital info' : reviewComponentType === 'prompt' ? 'prompt' : reviewComponentType === 'aboutMe' ? 'bio' : '' } make ${profileReview.bio.vitalInfo.firstName} seem more or less attractive?${isFriendReview ? `` : `(Required)`}`,
              true,
              handleFeedbackAndVerdictChange,
              setErrors,
              setProfileReview,
              profileReview,
              0
            )}
          </Box>

          {/* Verdict */}
          <Box
            sx={{
              px: 1,
              mt: 1, mb: 1,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            <Typography
              textAlign={'center'}
              sx={{
                mt: 1, mb: 1,
                width: '100%',
                fontWeight: 'bold',
                fontSize: '16px',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
              }}
            >
              Verdict*
            </Typography>

            <Box
              sx={{
                width: '100%',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {/* Thumb Down (No) */}
              <Box
                onClick={(e) => handleFeedbackAndVerdictChange(e, setErrors, setProfileReview, profileReview, -1, 'No')}
                sx={{
                  backgroundColor: 'white',
                  mx: 1,
                  width: '35px',
                  height: '35px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  boxShadow: 3,
                  border: (
                    reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'No'
                    || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'No'
                    || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'No'
                    || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'No'
                  ) ? 2 : 0,
                  borderColor: 'black',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ThumbDownIcon  
                  sx={{
                    color: (
                      reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'No'
                      || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'No'
                      || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'No'
                      || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'No'
                    ) ? 'red' : 'dimgray',
                  }}
                />
              </Box>

              {/* Sentiment Neutral (Somewhat) */}
              <Box
                onClick={(e) => handleFeedbackAndVerdictChange(e, setErrors, setProfileReview, profileReview, -1, 'Somewhat')}
                sx={{
                  backgroundColor: 'white',
                  mx: 1,
                  width: '35px',
                  height: '35px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  boxShadow: 3,
                  border: (
                    reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Somewhat'
                    || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Somewhat'
                    || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Somewhat'
                    || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Somewhat'
                  ) ? 2 : 0,
                  borderColor: 'black',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <SentimentNeutralIcon  
                  sx={{
                    color: (
                      reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Somewhat'
                      || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Somewhat'
                      || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Somewhat'
                      || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Somewhat'
                    ) ? 'black' : 'dimgray',
                  }}
                />
              </Box>
              
              {/* Thumb Up (Yes) */}
              <Box
                onClick={(e) => handleFeedbackAndVerdictChange(e, setErrors, setProfileReview, profileReview, -1, 'Yes')}
                sx={{
                  backgroundColor: 'white',
                  mx: 1,
                  width: '35px',
                  height: '35px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  boxShadow: 3,
                  border: (
                    reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Yes'
                    || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Yes'
                    || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Yes'
                    || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Yes'
                  ) ? 2 : 0,
                  borderColor: 'black',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ThumbUpIcon  
                  sx={{
                    color: (
                      reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Yes'
                      || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Yes'
                      || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Yes'
                      || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Yes'
                    ) ? 'blue' : 'dimgray',
                  }}
                />
              </Box>
              
              {/* Heart (Very) */}
              <Box
                onClick={(e) => handleFeedbackAndVerdictChange(e, setErrors, setProfileReview, profileReview, -1, 'Very')}
                sx={{
                  backgroundColor: 'white',
                  mx: 1,
                  width: '35px',
                  height: '35px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  boxShadow: 3,
                  border: (
                    reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Very'
                    || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Very'
                    || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Very'
                    || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Very'
                  ) ? 2 : 0,
                  borderColor: 'black',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <FavoriteIcon  
                  sx={{
                    color: (
                      reviewComponentType === 'mediaItem' && profileReview.mediaFeedback[componentIndex].verdict === 'Very'
                      || reviewComponentType === 'prompt' && profileReview.bioFeedback.promptsFeedback[componentIndex].verdict === 'Very'
                      || reviewComponentType === 'aboutMe' && profileReview.bioFeedback.aboutMeFeedback.verdict === 'Very'
                      || reviewComponentType === 'vitalInfo' && profileReview.bioFeedback.vitalInfoFeedback.verdict === 'Very'
                    ) ? 'green' : 'dimgray',
                  }}
                />
              </Box>

            </Box>

          </Box>
        </Box>
      }
    </Box>
  )
}